import { render, staticRenderFns } from "./p1s4c2PaymentLinks.vue?vue&type=template&id=6461cd0c"
import script from "./p1s4c2PaymentLinks.vue?vue&type=script&lang=js"
export * from "./p1s4c2PaymentLinks.vue?vue&type=script&lang=js"
import style0 from "./p1s4c2PaymentLinks.vue?vue&type=style&index=0&id=6461cd0c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports